import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import _ from 'lodash';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { DeleteTenantDialogComponent } from '../delete-tenant-dialog/delete-tenant-dialog.component';

@Component({
  selector: 'lib-tenants-button-renderer',
  templateUrl: './tenants-button-renderer.component.html',
  styleUrls: ['./tenants-button-renderer.component.scss']
})
export class TenantsButtonRendererComponent implements ICellRendererAngularComp {

  params: any;

  icon_edit!:string;
  icon_delete!:string;  

  routerLinkEditTenant!:string;

  constructor(public dialog: MatDialog,    
    private tenantService: TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    this.routerLinkEditTenant = _.isFunction(dataParams.routerLinkEditTenant) ? dataParams.routerLinkEditTenant(params) : _.get(params.data, dataParams.routerLinkEditTenant);
    return false;
  }

  agInit(params: ICellRendererParams): void {
    console.log("--------> tenants-button-renderer: params", params)
    this.params = params;

    this.icon_edit = this.params.icon_edit || null;
    this.icon_delete = this.params.icon_delete || null;
   
    this.routerLinkEditTenant = this.params.routerLinkEditTenant || null;
    this.refresh(params);
  }

  deleteTenant() {
    const rowData = [this.params.node.data];
    const id = rowData[0].id;
    const displayName = rowData[0].displayName;

    let tenantDto = new TenantDto;
    tenantDto.id = id;
    tenantDto.name = displayName;

    const dialogRef = this.dialog.open(DeleteTenantDialogComponent, {width:'800px', data:tenantDto});
    dialogRef.afterClosed().subscribe({
      next:() => {
        this.params.api.refreshInfiniteCache();
      }
    })
  }

}
